import "./modules/mapConfig";

// React
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import { createBrowserHistory } from "history";
import * as React from "react";
import * as ReactDOM from "react-dom";
import AppPage from "./pages/App";

// Redux
import { ConnectedRouter, routerMiddleware } from "connected-react-router";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import loggerMiddleware from "redux-logger";
import thunkMiddleware from "redux-thunk";
import createRootReducer, { initialState } from "./reducers/index";
// App
import * as moment from "moment/moment";
import { API_URL, CONFIG } from "./appconfig";
import { RootId } from "./constants/core.constant";
import { mapConfig } from "./constants/map.constant";
import "./css/index.scss";
import routes, { Route } from "./modules/routers";
import authService from "./services/api/AuthServices";

import * as io from "socket.io-client";
import Auth from "./modules/Auth";
import esriConfig = require("esri/config");
esriConfig.request.interceptors.push({
  before: function (params) {
    if (params.url.startsWith(API_URL)) {
      params.requestOptions.query = {
        ...params.requestOptions.query,
        token: localStorage.getItem("token"),
      };
    }
  },
});
moment.locale("vi");

const socket = io(API_URL, {
  transports: ["websocket"],
});
if (!Auth.isUserAuthenticated()) {
  socket.emit("token");
  socket.on("token", (payload) => {
    if (!Auth.isUserAuthenticated()) {
      localStorage.setItem("token", payload.accessToken);
      const countdown = new Date(payload.expired * 1000);
      // lấy token trước 5'
      countdown.setMinutes(countdown.getMinutes() - 5);
      const timeout = countdown.getTime() - Date.now();
      setTimeout(() => {
        socket.emit("token");
      }, timeout);
    }
  });
}

const constantMock = window.fetch;
window.fetch = function () {
  if (arguments.length === 2) {
    const requestUrl = arguments[0];
    if (requestUrl) {
      if (
        requestUrl.indexOf("sockjs-node") === -1 &&
        requestUrl.startsWith(API_URL)
      ) {
        let token;
        if (Auth.isUserAuthenticated()) {
          token = Auth.getToken();
        } else {
          token = localStorage.getItem("token");
        }
        const headers = arguments[1].headers as Headers;
        if (headers) {
          if (!headers.has("Authorization"))
            headers.append("Authorization", `Bearer ${token} `);
        }
      }
    }
  }

  // Get the parameter in arguments
  // Intercept the parameter here
  return constantMock.apply(this, arguments);
};

authService.getAppInfo(RootId, true).then((result) => {
  if (!result.config) {
    throw new Error("Không xác định được config webroot");
  }
  if (!result.config.mapConfig) {
    throw new Error("Không xác định được mapConfig");
  }
  if (!result.config.webRouters) {
    throw new Error("Không xác định được webRouters");
  }
  Object.assign(CONFIG, result.config);
  Object.assign(mapConfig, result.config.mapConfig);
  for (const route of result.config.webRouters as Array<Route>) {
    if (route) {
      const baseRoute = routes.find((f) => f.id === route.id);
      if (baseRoute) {
        Object.assign(baseRoute, route);
      } else {
        routes.push(route);
      }
    }
  }
  if (result.config.primaryColor) {
    document.documentElement.style.setProperty(
      "--primary-color",
      result.config.primaryColor
    );
  }
  if (result.config.secondaryColor) {
    document.documentElement.style.setProperty(
      "--secondary-color",
      result.config.secondaryColor
    );
  }

  //MUI THEME
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: result.config.primaryColor || "#f6b93b",
      },
      secondary: {
        main: result.config.secondaryColor || "#e55039",
      },
    },
    typography: {
      useNextVariants: true,
    },
    overrides: {
      MuiAppBar: {
        colorPrimary: {
          color: "#fff",
        },
      },
      MuiButton: {
        root: {
          textTransform: "none",
        },
      },
      MuiTab: {
        root: {
          minWidth: "unset",
          textTransform: "none",
        },
      },
      MuiCardContent: {
        root: {
          padding: "0 16px",
        },
      },
      MuiInputLabel: {
        root: {
          fontSize: 12,
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          "-webkit-line-clamp": 1,
          "-webkit-box-orient": "vertical",
        },
      },
    },
  });
  // ROUTER
  const history = createBrowserHistory();

  // REDUX

  const middleWares = [routerMiddleware(history), thunkMiddleware];

  process.env.NODE_ENV !== "production" && middleWares.push(loggerMiddleware);

  const store = createStore(
    createRootReducer(history), // root reducer with router state
    //@ts-ignore
    initialState,
    composeWithDevTools(applyMiddleware(...middleWares))
  );

  // RENDER
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <MuiThemeProvider theme={theme}>
          <AppPage />
        </MuiThemeProvider>
      </ConnectedRouter>
    </Provider>,
    document.querySelector("#root")
  );
});
